import { createSelector } from '@reduxjs/toolkit';

import { IAppState } from '../common/state';

export const selectMarkedListItems = createSelector(
  (state: IAppState) => state.results.markedList?.items,
  items => items || [],
);
